import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

// Using optional chaining to safely handle undefined state.layout
const selectDomain = (state: RootState) => state?.layout || initialState;

export const selectUser = (state: RootState) => selectDomain(state).user;
export const selectIsSidebarOpen = (state: RootState) =>
  selectDomain(state).isSidebarOpen;
export const selectLayoutLoading = (state: RootState) =>
  selectDomain(state).loading;
export const selectIsAuthenticated = (state: RootState) =>
  selectDomain(state).isAuthenticated;

export const selectUserProfile = createSelector(
  [selectDomain],
  layoutState => layoutState.user
);

export const selectProfileLoading = createSelector(
  [selectDomain],
  layoutState => layoutState.loading
);

export const selectProfileError = createSelector(
  [selectDomain],
  layoutState => layoutState.error
);

export const selectLayout = createSelector(
  [selectDomain],
  layoutState => layoutState
);

export const selectShowAiAssistant = (state: RootState) =>
  selectDomain(state).showAiAssistant;

export const selectCanAccessAiAssistant = createSelector(
  [selectUserProfile],
  () => true
);
